import { styled } from '@mui/system';
import clsx from 'clsx';
import React, { cloneElement } from 'react';
import { Radio, RadioProps } from '.';

interface RadioGroupProps {
  className?: string;
  childClassName?: string;
  children: React.ReactElement<RadioProps>[] | React.ReactElement<RadioProps>;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  preventDefault?: boolean;
}
const StyledRadioGroupWrap = styled('div')<any>`
  min-width: 300px;
  border-radius: 3px;
  border: 1px solid #1e8ae7;
  display: flex;
  align-items: center;
  & .c-radio-root {
    line-height: 0px;
    width: 100%;
    padding: 14px 20px;
  }
  & .c-radio {
    margin-bottom: 0px;
  }
  ${(props) => props.checked && `background-color: #EBF2FA`}
`;

const RadioGroup = React.forwardRef<HTMLInputElement, RadioGroupProps>(function RadioGroup(props, ref) {
  const { className, children, value, onChange, childClassName, preventDefault = false } = props;
  const cls = clsx({
    [className]: !!className,
  });

  return (
    <div className={cls}>
      {React.Children.map(children, (child: React.ReactElement) => {
        if (child.type !== Radio) {
          throw new Error('RadioGroup only accepts Radio components as children');
        }
        const checked = value === child.props.value;
        return (
          <StyledRadioGroupWrap checked={checked} ref={ref} className={childClassName}>
            {cloneElement(child as React.ReactElement<any>, {
              checked,
              onChange: (e) => onChange(e),
              preventDefault,
            })}
          </StyledRadioGroupWrap>
        );
      })}
    </div>
  );
});

export { RadioGroup };
